'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _MethodCreator = require('./MethodCreator');

var _MethodCreator2 = _interopRequireDefault(_MethodCreator);

var _ActionCreators = require('../change/ActionCreators');

var _ActionCreators2 = _interopRequireDefault(_ActionCreators);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _MethodCreator2.default)("Child", function (_this) {
    return {

        // change methods

        deleteSelf: function deleteSelf() {
            _this.dispatch(_ActionCreators2.default.deleteSelf());
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./~/parcels/lib/parcel/ChildParcelMethods.js
// module id = 738
// module chunks = 35783957827783